import React from 'react'
import styled from 'styled-components'
import { Row, Col } from 'react-bootstrap'

import data from './data'
import bgLine from './bgLine.svg'

function getPaddingTop(idx) {
  switch (+idx) {
    // case 0:
    //   return '-50px'
    case 2:
      return '50px'
    case 3:
      return '20px'
    case 4:
      return '20px'
    default:
      return '0px'
  }
}

export default ({ onScroll }) => {
  return (
    <Wrapper className="animated fadeInUp" onScroll={onScroll}>
      {data.map(({ title, date, descr, text, icon }, idx) => {
        const isEven = idx % 2 === 0

        return (
          <StyledRow
            isEven={isEven}
            key={idx}
            idx={idx}
            className="justify-content-md-center">
            <Col
              xs={isEven ? { span: 8, offset: 0 } : { span: 8, offset: 1 }}
              md={isEven ? { span: 6, offset: 1 } : { span: 6, offset: 2 }}>
              <Title>
                {title} <span style={{ opacity: 0.7 }}>{date}</span>{' '}
                <p style={{ opacity: 0.5 }}>{descr}</p>
              </Title>
              <Text dangerouslySetInnerHTML={{ __html: text }} />
            </Col>
            <Col
              xs={isEven ? { span: 3, offset: 1 } : { span: 3, offset: 0 }}
              md={isEven ? { span: 2, offset: 3 } : { span: 2, offset: 0 }}>
              <Icon
                style={{
                  marginLeft: isEven ? 0 : 'auto',
                }}
                src={icon}
              />
            </Col>
          </StyledRow>
        )
      })}
    </Wrapper>
  )
}
const Wrapper = styled.div`
  position: relative;
  margin-top: 30px;
  &::after {
    position: absolute;
    top: 11%;
    left: 50%;
    transform: translateX(-45%);
    content: ' ';
    display: block;
    width: 90%;
    height: 89%;
    background: url(${bgLine}) no-repeat center center;
    background-size: contain;
    @media (max-width: 1200px) {
      display: none;
    }
  }
`
const StyledRow = styled(Row)`
  padding-top: ${({ idx }) => getPaddingTop(idx)};
  height: 380px;
  align-items: center;
  flex-direction: ${({ isEven }) => (isEven ? 'row-reverse' : 'row')};
  @media (max-width: 1200px) {
    padding-top: 0;
    height: 300px;
  }
  @media (max-width: 768px) {
    padding-top: 0;
    height: auto;
    margin-bottom: 50px;
  }
`

const Title = styled.h3`
  margin-bottom: 10px;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  letter-spacing: -1px;
  p {
    display: block;
    font-size: 18px;
    font-weight: normal;
  }
  @media (max-width: 768px) {
    font-size: 18px;
  }
`
const Text = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 23px;
  opacity: 0.7;
  @media (max-width: 768px) {
    font-size: 14px;
  }
`
const Icon = styled.img`
  display: block;
  width: 100%;
  @media (max-width: 768px) {
    width: 100%;
  }
`
